// Host DOM ↔ dojo bindings that used to live as inline `mdsRequire([...], cb)` scripts
// in the Razor layouts. Moved into the bundle so they use REAL imports (topic,
// LoginPopupForm) instead of the window.mdsRequire global — which was defined by this
// same deferred module and therefore raced ("mdsRequire is not defined") against the
// classic inline scripts that called it at parse time.
//
// This module is imported by main.ts. The bundle is a deferred module, so it evaluates
// after the document is parsed — every element referenced here (#top_login_info,
// #topBar_layout, #mainFooter) already exists, and the window globals the layouts set
// (lytSidebar) are reachable via `window`.
import topic from 'dojo/topic';
import LoginPopupForm from 'WidgetCollection/User/LoginPopupForm';

const w = window as any;

// Called once from main.ts on dojo `ready` (widget system up, DOM parsed).
export default function wireHostBindings(): void {

// --- global click: publish /Global/Click, and the sidebar content-click topic -------
document.documentElement.addEventListener('click', (evt: MouseEvent) => {
  topic.publish('/Global/Click');

  if (typeof w.lytSidebar === 'undefined') { return; }

  const target = evt.target as HTMLElement | null;
  if (w.lytSidebar.isOpened === true && target
    && target.id !== 'menu_bars' && target.id !== 'menu_btn' && target.id !== 'menu_btn_alt') {
    const parent = target.parentNode as HTMLElement | null;
    if (parent && (parent.id === 'menu_bars' || parent.id === 'menu_btn_alt')) { return; }
    topic.publish('layout/contentNode_click');
  }
});

// --- window resize: keep the topbar height CSS var current + publish /Global/Resize ---
window.addEventListener('resize', () => {
  const topBar = document.getElementById('topBar_layout');
  if (topBar) {
    const height = window.getComputedStyle(topBar).height;
    w.topBar_height = height;
    document.documentElement.style.setProperty('--marginTopbar', height);
  }
  topic.publish('/Global/Resize');
});

// --- tab visibility change: publish /Global/VisibilityChange --------------------------
document.addEventListener('visibilitychange', (evt) => {
  topic.publish('/Global/VisibilityChange', evt);
});

// --- login hover-popup docked to the top-right corner --------------------------------
// (Formerly the inline `mdsRequire(["…/LoginPopupForm"], cb)` in _Layout: instantiate
// the popup once on load and dock it to #top_login_info.)
const loginNode = document.getElementById('top_login_info');
if (loginNode) {
  loginNode.addEventListener('click', (evt) => { evt.stopPropagation(); });
  if (!w.loginPopupForm) {
    const popup: any = new (LoginPopupForm as any)();
    popup.placeAt(loginNode);
    popup.startup();
    w.loginPopupForm = popup;
  }
}

}
